import { CUSTOMER_MANAGEMENT_CUSTOMER_CONTROLLER_ROOT_PATH } from "./root";

export const CUSTOMER_MANAGEMENT_CUSTOMER_UPDATE_CUSTOMER_SUFFIX = "/update";
/** /customer/update */
export const CUSTOMER_MANAGEMENT_CUSTOMER_UPDATE_CUSTOMER_PATH = `${
  CUSTOMER_MANAGEMENT_CUSTOMER_CONTROLLER_ROOT_PATH
}${
  CUSTOMER_MANAGEMENT_CUSTOMER_UPDATE_CUSTOMER_SUFFIX
}`;
